'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  ', ';\n  display: block;\n  line-height: normal;\n'], ['\n  ', ';\n  ', ';\n  display: block;\n  line-height: normal;\n']);

var _react = require('react');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _misc = require('HubStyleTokens/misc');

var _Styles = require('../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Heading = _styledComponents2.default.span.attrs({
  role: 'heading'
}).withConfig({
  displayName: 'Heading'
})(_templateObject, (0, _Styles.setFontSmoothing)(_misc.HEADING_FONT_SMOOTHING), (0, _Styles.singleDirectionModuleSpacing)());

Heading.propTypes = {
  'aria-level': _react.PropTypes.oneOf([1, 2, 3, 4, 5, 6])
};

Heading.defaultProps = {
  'aria-level': 2
};

exports.default = Heading;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/elements/Heading.js
// module id = 237
// module chunks = 0